export const width = {
  button: {
    md: 140,
  },
};
